// extracted by mini-css-extract-plugin
export default {"container":"Answers_container__XtmdU","questionContainer":"Answers_questionContainer__89Vqg"};